import React, { FC } from "react";
import { Link } from "react-router";
import { Box } from "@chakra-ui/react";
import { InfoIconV3 } from "../../../modules/InfoIconV3";

interface Props {
  total: string;
  title: string;
  infoText: string;
  viewLink: string;
}

const PersonaMiniCard: FC<Props> = ({ total, title, infoText, viewLink }) => {
  return (
    <div className="personaMiniCard">
      <Box className="cardTotal" fontSize="14px" lineHeight="40px">
        {total}
      </Box>
      <div className="cardTitle">
        <h2 aria-label={`${total} ${title}`}>{title}</h2>
        <InfoIconV3 tooltipText={infoText} placement="bottom" />
      </div>
      <div className="cardLink">
        <Link to={viewLink} className="personaModule-centerLink" aria-label={`${title}. View all`}>
          View All
        </Link>
      </div>
    </div>
  );
};

export default PersonaMiniCard;
